import { render } from "./LoginDesktop.vue?vue&type=template&id=6f7f50c5"
import script from "./LoginDesktop.vue?vue&type=script&lang=js"
export * from "./LoginDesktop.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__